import { z } from 'zod';

export const CheckJoinEligibilityServiceRequestSchema = z.object({});

export type CheckJoinEligibilityServiceRequest = z.infer<
  typeof CheckJoinEligibilityServiceRequestSchema
>;

export const CheckJoinEligibilityServiceResponseSchema = z.object({
  eligible: z.boolean(),
  restrictionType: z.string().nullable(),
});

export type CheckJoinEligibilityServiceResponse = z.infer<
  typeof CheckJoinEligibilityServiceResponseSchema
>;

export const RESTRICTION_TYPES = {
  EMPLOYEE: '임직원',
  REJECTED: '최근 반려 (90일 이내)',
  MINOR: '미성년자',
  DRAFT: '임시저장',
  DEACTIVATED: '활동정지',
  COMPLETE: '가입완료',
  ALREADY_REGISTERED: '이미등록됨',
} as const;

export type RestrictionType = keyof typeof RESTRICTION_TYPES;
